<div class="td-dynamic-slide-toggle-wrapper">
  <mat-slide-toggle [formControl]="control"
                    [attr.name]="name"
                    [required]="required">
    {{label}}
  </mat-slide-toggle>
  <span class="mat-hint td-dynamic-element-hint">{{hint}}</span>
</div>